import http from '@/services/http';

export const isDisplayErrorInLocalComponent = (errorCode) => {
  return [
    http.ERROR_CODE_VALIDATE,
    http.ERROR_CODE_BAD_REQUEST,
    http.ERROR_CODE_NOT_FOUND,
    http.ERROR_CODE_SERVER,
    http.ERROR_CODE_SERVICE_UNAVAILABLE,
  ].indexOf(errorCode) !== -1;
};

export const isDisplayFormError = (errorCode) => {
  return [
    http.ERROR_CODE_VALIDATE,
  ].indexOf(errorCode) !== -1;
};

export const notFound = (errorCode) => {
  return Number(errorCode) === http.ERROR_CODE_NOT_FOUND;
}
export const unauthorized = (errorCode) => {
  return Number(errorCode) === http.ERROR_CODE_UNAUTHORIZED;
}

export const formatZipCode = (zip) => {
  return zip ? "〒" + zip + ' ' : '';
}
